// Copyright (c) Docugami, Inc. All rights reserved.

export type GroupCollection<T> = {
    [key: string]: T[]
}

export function groupBy<T>(array: Array<T>, selector: (x: T) => string): GroupCollection<T> {
    const collection: GroupCollection<T> = {};
    array.forEach(x => {
        const groupKey = selector(x);
        let group = collection[groupKey];
        if (!group) {
            group = [];
            collection[groupKey] = group;
        }

        group.push(x);
    });

    return collection;
}

export function findLastIndex<T>(array: Array<T>, predicate: (value: T, index: number, obj: T[]) => boolean): number {
    let l = array.length;
    while (l--) {
        if (predicate(array[l], l, array))
            return l;
    }
    return -1;
}

// Checks the equality of two arrays assuming the same ordering
export function arrayEquals<T>(a: Array<T>, b: Array<T>): boolean {
    return a.length === b.length && a.every((aValue, idx) => aValue === b[idx]);
}